import { Building2 } from 'lucide-react';
import { CompareViewer } from '@/components/compare-viewer';
import { EmptyState } from '@/components/ui';

export function RenderPreview({ originalImage, renderImage }: { originalImage: string; renderImage: string | null }) {
  if (renderImage) return <CompareViewer originalImage={originalImage} renderImage={renderImage} />;

  return (
    <EmptyState
      className="bg-white border-solid border-slate-200 p-8 space-y-4 shadow-xs"
      iconClassName="w-16 h-16 bg-blue-50 border border-blue-100 text-blue-600 shadow-xs"
      icon={<Building2 className="w-8 h-8" />}
      title="Ready to Generate Architectural Render"
      description='Click "Generate Architectural Render" to trigger structural cleanup, scaffolding removal, and 100% geometric color mapping.'
    />
  );
}
